module.exports = __webpack_public_path__ + "img/publish-job-filled.f6fec281.svg";